var _style, _path, _ellipse, _circle, _g, _g2, _g3, _g4, _path2, _path3, _circle2, _path4, _circle3, _g5, _g6, _g7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 29.3 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t\t.bg{ fill: #2B3945; }\r\n\t\t.dark{ fill: #202C37; }\r\n\t\t.white{ fill: #FFFFFF; }\r\n\t\t.ligth{ fill: #EDEDED; }\r\n\t\t.yellow{ fill: #FF9200; }\r\n\t\t.gray{ fill: #4C565F; }\r\n\t\t.opa-1{ opacity: .1; }\r\n\t\t.opa-6{ opacity: .06; }\r\n\t\t.anim { animation: 4s animStar ease-in-out infinite alternate }\r\n\t\t@keyframes animStar {\r\n\t\t\t0% { transform: translate(0, 0); }\r\n\t\t\t40% { transform: translate(.02rem, .03rem); }\r\n\t\t\t60% { transform: translate(0, -.04rem); }\r\n\t\t\t100% { transform: translate(-.02rem, 0); }\r\n\t\t}\r\n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "bg",
    d: "M28.1,6H4.2C2.7,6,1,7.1,1,9.1v13.2c0,0.7,0.5,1.2,1.2,1.2h25.9c0.7,0,1.2-0.5,1.2-1.2V7.1 C29.2,6.5,28.7,6,28.1,6z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "ligth",
    cx: 12.6,
    cy: 22.6,
    rx: 12.6,
    ry: 4.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "yellow anim",
    cx: 8,
    cy: 5.8,
    r: 2.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "opa-6"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.3,
    cy: 22,
    rx: 3.3,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.7,
    cy: 20.2,
    rx: 2.4,
    ry: 0.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.7,
    cy: 25,
    rx: 2.1,
    ry: 0.6
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "opa-1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.3,
    cy: 22,
    rx: 2.4,
    ry: 0.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.7,
    cy: 20.2,
    rx: 2.1,
    ry: 0.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.5,
    cy: 25,
    rx: 1.5,
    ry: 0.4
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "yellow anim"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 21.4,
    cy: 8.2,
    r: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.7,
    cy: 16.9,
    r: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.8,
    cy: 14.5,
    r: 0.1
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "ligth"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "21.8,13.1 21.7,13.1 21.7,13 21.7,13 21.7,13.1 21.7,13.1 21.7,13.1 21.7,13.1 21.7,13.1 21.7,13.1 21.7,13.1 "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "26.2,12.2 26.2,12.2 26.2,12.2 26,12.2 26,12.2 26,12.2 26,12.4 26,12.4 26,12.4 26.2,12.4 26.2,12.4 26.2,12.4 "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3,16.5h0.1l0.6-1.1l-0.4-1.2l-0.8,1.9l0.2,0.3l-0.1,0.1l0,0c-0.1,0.2-0.5,0.9,0.1,1 C20.7,17.6,20.4,16.8,20.3,16.5v0.1V16.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23,9.4c0-0.1-0.1-0.2-0.2-0.2s-0.2,0.1-0.2,0.2c0,0.1,0.1,0.2,0.2,0.2v1.6h0.1V9.6C22.9,9.6,23,9.5,23,9.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "dark",
    d: "M23.1,11.9c-0.1,2.3-3.7,1-2.3-0.8l0,0C21.5,10.2,23.2,10.5,23.1,11.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "white",
    d: "M23.7,11.6c0,0-0.5-0.7-0.8-0.6l0,0c-0.1-0.1-0.1-0.1-0.2-0.2c-0.6-0.4-1.3-0.3-1.8,0.2c0.3-0.2,1.3-1,2.1,0.8 c-0.2,0.3-0.8,0.9-2,1l-0.2,0.3h-0.2l-0.1,0.4l0.2,2.3c0,0-0.1,0.2,0.1,0.2l0,0l-0.2,0.6l-0.1,0.9l-0.2,0.3v1.4l0.1,0.3l-0.1,0.7 l0.2,0.9l0.4,0.6l-0.4,0.7c-0.1,0.1,0,0.2,0,0.3h0.1c0.1,0,0.2,0,0.4-0.1c0.5-0.3,0.5-0.5,0.5-0.5s0.3,0,0.3-0.2s-0.5-2-0.5-2 l0.2-0.6l0.2-1.8h0.1v1.6l0.2,0.7l0.1,1.1l0.1,2c0,0,1,0.3,1.1,0.1c0.1-0.2-0.5-0.5-0.5-0.5l0.3-0.5l0.1-0.9L23,20.5l-0.1-1 l0.3-0.3l0.1-0.2v-1.4l-0.2-0.5L23,16.6L22.8,16c0.1,0,0.2,0,0.1-0.1c0,0,0.7-0.4,0.7-0.9c-0.1-0.5,0.1-2.6,0.1-2.6 S24,11.8,23.7,11.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6,12.9v-0.1c0,0-0.3-0.1-0.5,0c0,0-0.2,0.2-0.1,0.6c0.1,0.4,0.3,1.2,0.3,1.2l-0.9,0.9l0,0 c-0.3,0.1-0.8,0.3-0.6,0.7c0.2,0.5,0.6-0.1,0.8-0.4l0,0l1.3-0.7l0.3-0.2C24.1,14.3,23.9,13.6,23.6,12.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.8,
    cy: 11.9,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.6,
    cy: 7.6,
    r: 0.1
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "white",
    d: "M12,9.2c0,8.5-1.1,8.5-2.4,8.5c-0.7,0-1.3,0-1.7-1.2c-0.1-0.3-0.2-0.8-0.3-1.3c-0.2-1.3-0.3-3.2-0.3-6 C7.3,8.1,7.4,7,7.6,6c0.1-0.5,0.2-1,0.3-1.4c0.1-0.5,0.3-1,0.4-1.5c0.1-0.3,0.2-0.6,0.4-0.9c0.5-1.3,0.9-2,0.9-2S12,4.5,12,9.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "opa-1",
    d: "M8.7,2.2v14.9H8.3v-14C8.4,2.8,8.5,2.5,8.7,2.2z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "dark",
    cx: 9.5,
    cy: 6.1,
    r: 1.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "gray",
    d: "M12.4,17c-0.3-0.7-0.7-0.8-0.9-0.8v-0.1H7.6v0.1c-0.2,0-0.6,0.1-0.9,0.8C6.3,18.1,7,20.2,7,20.2s-0.4-2.8,1-2.8 c0.1,0.2,0.3,0.3,0.4,0.4v0.8h2.2v-0.7c0.2-0.1,0.4-0.3,0.6-0.5c1.4,0,1,2.8,1,2.8S12.9,18.1,12.4,17z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "bg",
    cx: 9.5,
    cy: 6.1,
    r: 1
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "yellow"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.9,6L26.9,6c-0.1,1.4,1.1,2.5,2.4,2.5V8.4C28,8.4,27,7.3,26.9,6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8,6L25.8,6c-0.1,2,1.5,3.6,3.5,3.6V9.5C27.3,9.5,26,7.9,25.8,6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6,6L24.6,6c-0.1,2.6,2.1,4.8,4.7,4.8v-0.1C26.7,10.7,24.8,8.6,24.6,6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "15.9,13.3 15.8,13.3 15.8,13.1 15.7,13.1 15.7,13.3 15.5,13.3 15.5,13.3 15.7,13.3 15.7,13.5 15.8,13.5 15.8,13.3 "
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "white anim"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "15.1,16.1 14.9,16.1 14.9,15.9 14.8,15.9 14.8,16.1 14.6,16.1 14.6,16.2 14.8,16.2 14.8,16.4 14.9,16.4 14.9,16.2 15.1,16.2 "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "3.3,11.8 3.1,11.8 3.1,11.6 3,11.6 3,11.8 2.8,11.8 2.8,11.9 3,11.9 3,12.1 3.1,12.1 3.1,11.9 3.3,11.9 "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "17.9,10.6 17.7,10.6 17.7,10.3 17.5,10.3 17.5,10.6 17.3,10.6 17.3,10.7 17.5,10.7 17.5,11 17.7,11 17.7,10.7 17.9,10.7 "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "27.9,15.2 27.7,15.2 27.7,15 27.6,15 27.6,15.2 27.5,15.2 27.5,15.3 27.7,15.3 27.7,15.4 27.6,15.4 27.6,15.3 27.9,15.3 "
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "white"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.3,
    cy: 8.7,
    r: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.9,
    cy: 20.4,
    r: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.6,
    cy: 10.2,
    r: 0.2
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "18.5,15.1 18.4,15.1 18.4,15 18.3,15 18.3,15.1 18.2,15.1 18.2,15.2 18.3,15.2 18.3,15.4 18.4,15.4 18.4,15.2 18.5,15.2 "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "3.7,18 3.4,18 3.4,17.8 3.3,17.8 3.3,18 3.1,18 3.1,18.2 3.3,18.2 3.3,18.4 3.4,18.4 3.4,18.2 3.7,18.2 "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.8589f15f7a7c38218442a5b148fefe58.svg";
export { ForwardRef as ReactComponent };